// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3oYG7","signatureBlock":"Footer_signatureBlock__6rDEM","signature":"Footer_signature__2WoK-"};